import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import renderField from '../../../shared/components/form/TextField';
import renderEditor from '../../../shared/components/tinymce/TinyMCE';
import hiddenField from '../../../shared/components/form/HiddenField';

class RenderTask extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  render() {
    const {
      fields,
      meta: { error, submitFailed },
    } = this.props;
    const { moveToUp, moveToDown } = RenderTask;

    return (
      <div className="form__form-group">
        {fields.map((task, index) => (
          <div key={index}>
            <div className="form__form-group">
              <span className="form__form-group-label">
                <strong>Название задания # {index + 1}</strong>
              </span>
              <div className="form__form-group-field">
                <Field name={`${task}.name`} component={renderField} type="text" placeholder="Название задания" />
                <Field name={`${task}.id`} component={hiddenField} />
                <div className="form__form-group-icon">
                  <ArrowUpBold onClick={() => moveToUp(fields, index)} />
                </div>
                <div className="form__form-group-icon">
                  <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
                </div>
                <div className="form__form-group-icon">
                  <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
                </div>
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Контент для задания # {index + 1}</span>
              <div className="form__form-group-field">
                <Field name={`${task}.content`} component={renderEditor} />
              </div>
            </div>
          </div>
        ))}
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" size="sm" onClick={() => fields.push({})}>
            Добавить задание
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RenderTask;
